<template>
  <div class="container mt-5">
    <inline-svg v-if="icon" class="mt-5" :src="require(`@/assets/${icon}.svg`)" />
    <h2 data-cy="basicPageHeading">{{ title }}</h2>
    <p>{{ subTitle }}</p>
    <mobialis-button
      v-if="callToAction"
      width="w-auto"
      class="mt-3 cta"
      v-av-analytics-cta-interaction="{
        elementText: callToAction,
        elementSubtype: 'cta_button',
        eventActionResult: 'open',
      }"
      @click="navigate"
      >{{ callToAction }}
    </mobialis-button>
  </div>
</template>

<script>
export default {
  name: 'BasicPage',
  props: {
    title: {
      type: String,
      required: false,
    },
    subTitle: {
      type: String,
      required: false,
    },
    callToAction: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    navigateToRouteName: {
      type: String,
      required: false,
    },
  },
  methods: {
    navigate() {
      this.$emit('ctaClicked');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables/breakpoints';

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 500px;
}

/* Mobile only*/
@media only screen and (max-width: $breakpoint-mobile) {
  .cta {
    width: 100% !important;
  }
}
</style>
